<template>
  <b-modal
    id="json-viewer"
    title="JSON"
    header-bg-variant="dark"
    header-close-variant="light"
    title-class="text-light font-18"
    hide-footer
    size="xl"
  >
    <div class="grid-json">
      <div class="item-grid">
        <h4>Pagarme</h4>
        <div>
          <!-- {{ dataJson.remote }} -->
          <JsonViewer
            :value="dataJson.remote || { nenhum_dado_encontrado: '' }"
            class="my-theme"
          />
        </div>
      </div>

      <div class="item-grid">
        <h4>Greenn</h4>
        <div>
          <JsonViewer
            :value="dataJson.local || { nenhum_dado_encontrado: '' }"
          />
        </div>
      </div>
    </div>
  </b-modal>
</template>

<script>
import JsonViewer from 'vue-json-viewer'

export default {
  components: {
    JsonViewer,
  },
  props: {
    dataJson: {
      type: Object,
      default: () => {
        return {}
      },
    },
  },
  data() {
    return {}
  },
}
</script>

<style scoped lang="scss">
.grid-json {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 40px;
}
@media (max-width: 768px) {
  .grid-json {
    grid-template-columns: 1fr;
  }
}
.item-grid {
  max-height: 550px;
  overflow: auto;
}
.item-grid::-webkit-scrollbar {
  width: 12px;
}

.item-grid::-webkit-scrollbar-track {
  background: #f7f7f7;
}

.item-grid::-webkit-scrollbar-thumb {
  background-color: #ccc;
  border-radius: 20px;
  border: 3px solid #f7f7f7;
}
</style>